import * as base from 'utils/geoFencing.js';

export default async function geoFencing(getGeo, options) {

	let locale = window.navigator.userLanguage || window.navigator.language;
	let [lang, region] = locale?.split('-');

	if (lang !== 'fr') {
		return base.default(getGeo, options);
	}

	const getGeo2 = async () => {
		const realGeo = await getGeo();
		const countryCode = realGeo.countryCode;

		if (countryCode === 'ca') {
			return { countryCode: 'ca_fr' };
		}
		return realGeo;
	};

	return base.default(getGeo2, options);
}
